import React from 'react';
import './block-title.scss';

const BlockTitle = ({
    className = '',
    eyebrow,
    title,
    description,
    maxWidth,
    headingTag = 'h2',
    headingTagClass = '',
    hasExternalLink,
}) => {
    const TitleTag = headingTag; // dynamic tag

    return (
        <header className={`block-title ${className}`} style={{ maxWidth }} data-aos="fade-up">
            {hasExternalLink ? (
                <>
                    {eyebrow && <span className="eyebrow">{eyebrow}</span>}
                    {title && <TitleTag className={headingTagClass}>{title}</TitleTag>}
                    {description && <div className="content">{description}</div>}
                </>
            ) : (
                <>
                    {eyebrow && (
                        <span
                            className="eyebrow"
                            dangerouslySetInnerHTML={{ __html: eyebrow }}
                        />
                    )}
                    {title && (
                        <TitleTag
                            className={headingTagClass}
                            dangerouslySetInnerHTML={{ __html: title }}
                        />
                    )}
                    {description && (
                        <div
                            className="content"
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    )}
                </>
            )}
        </header>
    );
};

export default BlockTitle;
